import { useEffect, useState } from "react";
import { Button, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { TiFlowChildren } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import franchiseAdminAPI from "../../api/franchiseAdminAPI";
import Pagination from "../../components/Pagination";

const Franchises = () => {
  const [franchises, setFranchises] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchFranchises();
  }, [page, pageSize]);

  const fetchFranchises = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await franchiseAdminAPI.getFranchises1ByPagination(
        page,
        pageSize,
      );
      setFranchises(response.data.content || []);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      console.error("Error fetching franchises:", error);
      setFranchises([]);
      setTotalPages(0);
      setError("Failed to load franchises. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("franchise-level1", selectedPage);
  };

  const handleAddFranchise = () => {
    // Navigate to the Add Franchise page
    navigate("/master-admin-dashboard/franchises/add");
  };

  const handleNavigate = (franchiseId, organization, location) => {
    navigate("/master-admin-dashboard/franchises/level2", {
      state: {
        parentId: franchiseId,
        parentOrganization: organization,
        parentLocation: location,
      },
    });
  };
  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <h1>
        <strong>Franchises</strong>
      </h1>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <p>This is the Franchises page</p>
        <Button variant="primary" onClick={handleAddFranchise}>
          Add Franchise
        </Button>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Manage By</th>
            <th>Franchise L1</th>
            <th>Location FA1</th>
            <th>Created At</th>
            <th>ReferralCode</th>
            <th>Action</th>
            <th>Customers</th>
          </tr>
        </thead>
        <tbody>
          {franchises.map((franchise, index) => (
            <tr key={franchise.id ?? index}>
              <td>{franchise.id}</td>
              <td>{franchise.email}</td>
              <td>{franchise.organization}</td>
              <td>{franchise.location}</td>
              <td>{franchise.createdAt}</td>
              <td>{franchise.referralCode}</td>
              <td>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>View Level 2 Franchises</Tooltip>}
                >
                  <Button
                    variant="link" // keeps it icon-like (no heavy styling)
                    style={{ padding: 0, fontSize: "20px" }}
                    onClick={() =>
                      handleNavigate(
                        franchise.id,
                        franchise.organization,
                        franchise.location,
                      )
                    }
                  >
                    <TiFlowChildren />
                  </Button>
                </OverlayTrigger>
              </td>
              <td>
                <Button
                  onClick={() =>
                    navigate("/master-admin-dashboard/franchises/customers", {
                      state: {
                        franchiseId: franchise.id,
                        referralCode: franchise.referralCode,
                      },
                    })
                  }
                >
                  Customers
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div style={{ marginTop: "auto" }}>
        {franchises.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
    </div>
  );
};

export default Franchises;
